import {
  IMovableTextObjectStyleConfiguration,
  IBackgroundColorConfiguration,
  IBorderColorConfiguration,
  IObjectColorConfiguration,
  IEnableConfiguration,
} from "../../../../domain/configuration";
import {
  PaintStyle,
  TextStyle,
} from "../../../../domain/drawing";
import {
  MovableTextBoxItem,
} from "../../../../domain/document/items";
import { AbstractTextObjectStyleReader } from "./AbstractTextObjectStyleReader";
import { FixedColorSource } from "./FixedColorSource";

export class MovableTextObjectStyleReader extends AbstractTextObjectStyleReader<MovableTextBoxItem> {
  constructor(private readonly _configuration: IMovableTextObjectStyleConfiguration) {
    super();
  }

  protected readSpecifiedPaintStyle(source: MovableTextBoxItem, shouldInputFree: boolean): PaintStyle {
    return source.paintStyleOnEditing;
  }

  protected readBackgroundColorConfiguration(source: MovableTextBoxItem, shouldInputFree: boolean): IBackgroundColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  protected readBorderColorConfiguration(source: MovableTextBoxItem, shouldInputFree: boolean): IBorderColorConfiguration {
    return this.readObjectStyleConfiguration(source, shouldInputFree);
  }

  private readObjectStyleConfiguration(source: MovableTextBoxItem, shouldInputFree: boolean): IObjectColorConfiguration {
    if (source.injectedRule && source.injectedRule.isEditDisabled) {
      return FixedColorSource.uneditable;
    }
    if (!(source.shouldInputFree || (source.isFreeInputable && shouldInputFree))) {
      if (0 < source.mksTemplateFormats.length) {
        return this._configuration.mksTemplate;
      }
      if (0 < source.dynamicTemplateFormats.length) {
        return this._configuration.dynamicTemplate;
      }
    }
    if (!source.isFreeInputable) {
      // 文書内転記が指定されている、もしくはフリー入力が不可に指定されているオブジェクト
      // フリー入力不可の場合に関連付けの色が適用されるのはV1のバグと思われるが、同様の挙動に合わせこんでいる
      return this._configuration.related;
    }
    return source.printBehavior.shouldPrint
      ? this._configuration.default
      : this._configuration.notPrintable;
  }

  public readTextStyle(source: MovableTextBoxItem, shouldInputFree: boolean, isFocused: boolean): TextStyle {
    return isFocused
      ? this.toFreeInputTextStyle(source)
      : this.toTextStyle(source);
  }

  protected readForegroundDisplayConfiguration(): IEnableConfiguration {
    return this._configuration.foreground;
  }
}
